module.exports = __webpack_public_path__ + "media/images/recruit/top/stone_large-4385159725bcc403a295218390a8f4fc.png";